import React from "react";

import {
  Button,
  Card,
  CardBody,
  Content,
  Divider,
  Grid,
  GridItem,
  List,
  ListItem,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";

import {
  ExternalLinkAltIcon
} from "@patternfly/react-icons";

import {
  parentDocumentGroups,
  parentInsuranceDocuments,
  parentJournal
} from "./data/parentDocuments";


const DocumentList = ({ documents }) => (
  <Content>
    <List isPlain>
      {documents.map((document) => (
        <ListItem key={document.id}>
          <a
            href={document.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {document.title}{" "}
            <ExternalLinkAltIcon />
          </a>
        </ListItem>
      ))}
    </List>
  </Content>
);


const ParentPage = () => {
  return (
    <PageSection isWidthLimited>
      <Stack hasGutter>
        <StackItem>
          <Grid>
            <GridItem span={12} md={8} mdOffset={2}>
              <Content style={{ textAlign: "center" }}>
                <h1>Dla rodzica</h1>

                <p>
                  Dokumenty, informacje i materiały dla rodziców i uczniów.
                </p>
              </Content>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid hasGutter>
            <GridItem span={12} lg={4}>
              <Card isFullHeight isGlass>
                <CardBody>
                  <Stack hasGutter>
                    {parentDocumentGroups.map((group, index) => (
                      <React.Fragment key={group.id}>
                        {index > 0 && (
                          <StackItem>
                            <Divider />
                          </StackItem>
                        )}

                        <StackItem>
                          <Stack hasGutter>
                            <StackItem>
                              <Content>
                                <h2>{group.title}</h2>
                              </Content>
                            </StackItem>

                            <StackItem>
                              <DocumentList
                                documents={group.documents}
                              />
                            </StackItem>
                          </Stack>
                        </StackItem>
                      </React.Fragment>
                    ))}
                  </Stack>
                </CardBody>
              </Card>
            </GridItem>

            <GridItem span={12} lg={5}>
              <Card isFullHeight isGlass>
                <CardBody>
                  <Stack hasGutter>
                    <StackItem>
                      <Content>
                        <h2>Dziennik elektroniczny</h2>

                        <p>
                          Rodzic i uczeń zakładają indywidualne konta.
                          Rodzic nie udostępnia dziecku hasła do swojego
                          konta.
                        </p>
                      </Content>
                    </StackItem>

                    <StackItem>
                      <Content>
                        <h3>Jak uzyskać dostęp?</h3>

                        <ol>
                          <li>
                            Otwórz stronę dziennika elektronicznego.
                          </li>

                          <li>
                            Kliknij <strong>Załóż konto</strong> i wpisz
                            adres e-mail podany wychowawcy.
                          </li>

                          <li>
                            Zaznacz opcję <strong>Nie jestem robotem</strong>
                            i kliknij <strong>Wyślij wiadomość</strong>.
                          </li>

                          <li>
                            Sprawdź pocztę elektroniczną i otwórz link
                            otrzymany w wiadomości.
                          </li>

                          <li>
                            Ustaw nowe hasło do konta.
                          </li>

                          <li>
                            Zaloguj się przy użyciu adresu e-mail
                            i utworzonego hasła.
                          </li>

                          <li>
                            Rodzic może przeglądać informacje dotyczące
                            dziecka w odpowiednich zakładkach systemu.
                          </li>

                          <li>
                            Uczeń może przeglądać informacje dostępne
                            na swoim koncie. Dodatkowe informacje znajdują
                            się w zakładce <strong>Pomoc</strong>.
                          </li>
                        </ol>
                      </Content>
                    </StackItem>

                    <StackItem>
                      <Button
                        component="a"
                        variant="primary"
                        href={parentJournal.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        icon={<ExternalLinkAltIcon />}
                        iconPosition="end"
                      >
                        Otwórz dziennik elektroniczny
                      </Button>
                    </StackItem>

                    <StackItem>
                      <Content>
                        <a
                          href={parentJournal.instructionUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Instrukcja pierwszego logowania{" "}
                          <ExternalLinkAltIcon />
                        </a>
                      </Content>
                    </StackItem>
                  </Stack>
                </CardBody>
              </Card>
            </GridItem>

            <GridItem span={12} lg={3}>
              <Card isFullHeight isGlass>
                <CardBody>
                  <Stack hasGutter>
                    <StackItem>
                      <Content>
                        <h2>Ubezpieczenie NNW</h2>
                      </Content>
                    </StackItem>

                    <StackItem>
                      <DocumentList
                        documents={parentInsuranceDocuments}
                      />
                    </StackItem>
                  </Stack>
                </CardBody>
              </Card>
            </GridItem>
          </Grid>
        </StackItem>
      </Stack>
    </PageSection>
  );
};


export default ParentPage;